// extracted by mini-css-extract-plugin
module.exports = {"label":"RSTextField_label__I8Mvi","input":"RSTextField_input__0v2JI"};